export default __webpack_public_path__ + "static/desktop-d8f505ba19e5b95f0daa8911f2cf00f6.svg";